// Utility function to format currency in Indian style (Lakhs/Crores)
export const formatIndianCurrency = (value, includeSymbol = true, decimals = 2) => {
  const symbol = includeSymbol ? '₹' : '';
  const absValue = Math.abs(value);
  
  if (absValue >= 10000000) {
    // Crores (1 Crore = 1,00,00,000)
    return `${symbol}${(value / 10000000).toFixed(decimals)}Cr`;
  } else if (absValue >= 100000) {
    // Lakhs (1 Lakh = 1,00,000)
    return `${symbol}${(value / 100000).toFixed(decimals)}L`;
  } else if (absValue >= 1000) {
    // Thousands
    return `${symbol}${(value / 1000).toFixed(decimals)}K`;
  } else {
    return `${symbol}${value.toLocaleString('en-IN')}`;
  }
};

// Format with full Indian number system (with commas)
export const formatIndianNumber = (value) => {
  return value.toLocaleString('en-IN');
};

// Format for chart axis (shorter version)
export const formatChartAxis = (value) => {
  const absValue = Math.abs(value);
  
  if (absValue >= 10000000) {
    return `₹${(value / 10000000).toFixed(1)}Cr`;
  } else if (absValue >= 100000) {
    return `₹${(value / 100000).toFixed(1)}L`;
  } else if (absValue >= 1000) {
    return `₹${(value / 1000).toFixed(0)}K`;
  } else {
    return `₹${value}`;
  }
};

// Format for tooltips (more detailed)
export const formatTooltipCurrency = (value) => {
  const symbol = '₹';
  const absValue = Math.abs(value);
  
  if (absValue >= 10000000) {
    return `${symbol}${(value / 10000000).toFixed(2)}Cr (${symbol}${value.toLocaleString('en-IN')})`;
  } else if (absValue >= 100000) {
    return `${symbol}${(value / 100000).toFixed(2)}L (${symbol}${value.toLocaleString('en-IN')})`;
  } else {
    return `${symbol}${value.toLocaleString('en-IN')}`;
  }
};

